import React from 'react';
import ModalMathReq from './ModalMathReq';
import ModalMathIntensity from './ModalMathIntensity';

function ModalMath(props) {
  const { degree, tenant } = { ...props };

  return (
    <div className="modal-math-container">
      <hr className="modal-math-horizontal-line" aria-hidden />
      <ModalMathReq degree={degree} />
      <ModalMathIntensity
        mathIntensity={degree.mathIntensity}
        tenant={tenant}
      />
      <hr className="modal-math-horizontal-line" aria-hidden />
    </div>
  );
}

export default ModalMath;
